import React from 'react';
import { Card, Steps } from 'antd';
import { 
  CheckCircleOutlined, 
  SyncOutlined, 
  ClockCircleOutlined, 
  CloseCircleOutlined,
  TruckOutlined 
} from '@ant-design/icons';

const { Step } = Steps;

const OrderStatusSteps = ({ currentStatus, onStatusChange }) => {
  const getStatusStep = (status) => {
    switch (status) {
      case 'Shipped':
        return 2;
      case 'PartiallyShipped':
        return 1;
      case 'Unshipped':
      default:
        return 0;
    }
  };

  const getStepStatus = (stepIndex, currentStep, status) => {
    if (status === 'Canceled') {
      return 'error';
    }
    if (stepIndex < currentStep) {
      return 'finish';
    }
    if (stepIndex === currentStep) {
      return 'process';
    }
    return 'wait';
  };

  const currentStep = getStatusStep(currentStatus);

  return (
    <div style={{ marginBottom: 20 }}>
      <Steps 
        current={currentStep} 
        className="order-status-steps"
        status={currentStatus === 'Canceled' ? 'error' : 'process'}
      >
        <Step
          title="Unshipped"
          description="Order received, not yet shipped"
          icon={<ClockCircleOutlined />}
          onClick={() => onStatusChange('Unshipped')}
          style={{ cursor: 'pointer' }}
          status={getStepStatus(0, currentStep, currentStatus)}
        />
        <Step
          title="Partially Shipped"
          description="Some items have been shipped"
          icon={<SyncOutlined spin={currentStatus === 'PartiallyShipped'} />}
          onClick={() => onStatusChange('PartiallyShipped')}
          style={{ cursor: 'pointer' }}
          status={getStepStatus(1, currentStep, currentStatus)}
        />
        <Step
          title="Shipped"
          description="All items have been shipped"
          icon={<TruckOutlined />}
          onClick={() => onStatusChange('Shipped')}
          style={{ cursor: 'pointer' }}
          status={getStepStatus(2, currentStep, currentStatus)}
        />
        <Step
          title="Canceled"
          description="Order has been canceled"
          icon={<CloseCircleOutlined />}
          onClick={() => onStatusChange('Canceled')}
          style={{ cursor: 'pointer' }}
          status={currentStatus === 'Canceled' ? 'error' : 'wait'}
        />
      </Steps>
    </div>
  );
};

export default OrderStatusSteps; 